let currentNumber = 0;

export function generateSerialNumber(): string {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  // Generate a random 4-digit number
  const random = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
  
  // Combine all elements to create a unique serial number with separators
  const dateComponent = `${year}-${month}-${day}`;
  const timeComponent = `${hours}:${minutes}:${seconds}`;
  return `GRP|${dateComponent}|${timeComponent}|${random}`;
}